import React from 'react'
import Layout from '../../Components/Layout/Layout'

const Inicio = () => {
  return (
    <Layout>
      
      
    </Layout>
  )
}

export default Inicio
